import type { CSSProperties } from 'react'

export const offscreenHost: CSSProperties = {
  position: 'absolute',
  top: 0,
  left: -20000,
  width: 1200,
  height: 800,
  overflow: 'hidden',
  opacity: 0,
  pointerEvents: 'none',
}
